// SlideTypeListV5 preview flag — additive, off by default.
// Flag ON renders SlideTypeListV5 in the add-slide popup, OFF preserves V4.
// Force on locally with `?unleashOverride=AHA-slide-picker-v5:on`.
export const SLIDE_PICKER_V5_FLAG = 'AHA-slide-picker-v5'
